import { Box, Paper, Radio, Typography } from "@mui/material";

const ORANGE = "#FB8E00";

export function MethodCard({
    selected,
    title,
    description,
    meta,
    icon,
    onClick,
}: {
    selected: boolean;
    title: string;
    description: string;
    meta: string;
    icon: React.ReactNode;
    onClick: () => void;
}) {
    return (
        <Paper
            elevation={0}
            onClick={onClick}
            sx={{
                flex: 1,
                p: 1.75,
                borderRadius: "14px",
                border: "1.5px solid",
                borderColor: selected ? ORANGE : "rgba(0,0,0,0.08)",
                bgcolor: selected ? "rgba(251,142,0,0.045)" : "var(--fx-surface-base, #FFFFFF)",
                cursor: "pointer",
                transition: "border-color 0.15s ease, background 0.15s ease",
                "&:hover": {
                    borderColor: selected ? ORANGE : "rgba(0,0,0,0.18)",
                    bgcolor: selected ? "rgba(251,142,0,0.06)" : "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.015)",
                },
            }}
        >
            <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.4 }}>
                <Box
                    sx={{
                        width: 36,
                        height: 36,
                        borderRadius: "10px",
                        bgcolor: selected ? "rgba(251,142,0,0.12)" : "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.04)",
                        color: selected ? ORANGE : "#555",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                    }}
                >
                    {icon}
                </Box>

                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                        <Radio
                            checked={selected}
                            sx={{
                                p: 0,
                                color: "rgba(var(--fx-surface-textrgb, 15, 23, 42), 0.28)",
                                "&.Mui-checked": {
                                    color: ORANGE,
                                },
                            }}
                        />

                        <Typography
                            sx={{
                                fontSize: 14,
                                fontWeight: 900,
                                color: "var(--fx-surface-text, #0F172A)",
                                lineHeight: 1.2,
                            }}
                        >
                            {title}
                        </Typography>
                    </Box>

                    <Typography
                        sx={{
                            mt: 0.7,
                            fontSize: 12.5,
                            fontWeight: 500,
                            color: "var(--fx-surface-textsecondary, #64748B)",
                            lineHeight: 1.35,
                        }}
                    >
                        {description}
                    </Typography>

                    <Typography
                        sx={{
                            mt: 0.9,
                            fontSize: 11.5,
                            fontWeight: 800,
                            color: selected ? ORANGE : "#777",
                        }}
                    >
                        {meta}
                    </Typography>
                </Box>
            </Box>
        </Paper>
    );
}